<template>
  <v-card class="mb-3">
    <v-card-title
      v-if="typeof noticeObj.title !== 'undefined' && noticeObj.title !== ''"
      class="pt-2 pb-2 font-weight-bold subtitle-2">
      <v-icon v-if="noticeObj.homework === 1">fa-pencil-alt</v-icon>
      <v-icon v-else>message</v-icon>
      &nbsp;
      <span v-if="noticeObj.homework === 1">Homework:&nbsp;</span>
      <span>{{ noticeObj.title }}</span>
    </v-card-title>

    <v-card-title
      v-if="typeof noticeObj.event_title !== 'undefined' && noticeObj.event_title !== ''"
      class="pt-2 pb-2 font-weight-bold subtitle-2">
      <span>{{ noticeObj.event_title }}</span>
    </v-card-title>

    <v-divider/>
    <v-card-text
      style="overflow-wrap: break-word; overflow: scroll;"
      v-html="noticeObj.contents"/>

    <!-- CHANGED: attached files now get an icon, a preview toggle, a download link, and inline preview -->
    <v-card-text v-if="typeof noticeObj.files !== 'undefined' && noticeObj.files.length > 0">
      <div class="mb-1">Attached Files:</div>

      <div
        v-for="file in noticeObj.files"
        :key="file.id"
        class="mb-2">
        <v-row
          align="center"
          no-gutters>
          <v-col cols="auto">
            <v-icon small>{{ getFileIcon(file.filename) }}</v-icon>
          </v-col>
          <v-col class="pl-1">
            <span>{{ file.filename }}</span>
          </v-col>
          <v-col cols="auto">
            <v-btn
              small
              text
              color="primary"
              v-if="isPreviewable(file.filename)"
              @click="togglePreview(file)">
              {{ isPreviewOpen(file) ? 'Hide Preview' : 'Show Preview' }}
            </v-btn>
            <v-btn
              small
              text
              color="secondary"
              :href="file.href"
              target="_blank"
              rel="noopener">
              {{ getFileType(file.filename) === 'pdf' ? 'Download PDF' : 'Open Original' }}
            </v-btn>
          </v-col>
        </v-row>

        <v-expand-transition>
          <div
            v-if="isPreviewOpen(file)"
            class="mt-2">
            <div
              v-if="getFileType(file.filename) === 'pdf'"
              class="file-preview">
              <pdf-viewer :src="file.href"/>
            </div>

            <div
              v-else-if="getFileType(file.filename) === 'image'"
              class="file-preview">
              <v-img
                :src="file.href"
                max-height="500"
                contain/>
            </div>
          </div>
        </v-expand-transition>
      </div>
    </v-card-text>

    <v-card-text v-if="noticeObj.homework === 1">Homework Due Date: {{ noticeObj.homework_due_date }}</v-card-text>

    <!-- for event -->
    <v-card-title
      v-if="typeof noticeObj.event_title !== 'undefined' && noticeObj.event_title !== ''">
      <v-card-text v-if="noticeObj.location !== 'undefined' && noticeObj.location !=='' ">
        <v-icon v-if="noticeObj.location !== 'undefined' && noticeObj.location !== ''">fas fa-map-marker-alt</v-icon>
        &nbsp;
        <span><b>Location:</b> {{ noticeObj.location }}</span>
      </v-card-text>

      <v-card-text v-if="noticeObj.event_time !== 'undefined' && noticeObj.event_time !=='' ">
        <v-icon v-if="noticeObj.event_time !== 'undefined' && noticeObj.event_time !== ''">far fa-clock</v-icon>
        &nbsp;
        <span><b>Time:</b> {{ noticeObj.event_time }}</span>
      </v-card-text>
    </v-card-title>

    <v-divider/>
    <v-card-actions class="caption pt-1 pb-1 pl-3 pr-2">
      <span v-if="noticeObj.teacher !== ''">Posted by {{ noticeObj.teacher }}<br>{{ noticeObj.date }}</span>
      <v-spacer/>
      <v-btn
        depressed
        small
        :color="colourTag"
        :ripple="false"
        class="black--text"
        style="font-size: 10px; min-width:0px"
        v-if="tag !== ''">{{ tag }}</v-btn>
      <v-btn
        icon
        @click="toggleFavourite(noticeObj.id)">
        <v-icon
          color="yellow"
          v-if="favourite == 1">star</v-icon>
        <v-icon
          v-else>star_border</v-icon>
      </v-btn>
      <v-btn
        icon
        :href="getEmailURI"
        v-if="!disableReplyButton">
        <v-icon>reply</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// NEW: reuses the same PdfViewer used on the Newsletters page
import PdfViewer from './PdfViewer.vue'

export default {
  components: {
    PdfViewer
  },

  props: {
    noticeObj: {
      type: Object,
      default: () => { return {} }
    }
  },

  data: function () {
    return {
      favourite: this.noticeObj.fav,
      // NEW: tracks which attached files currently have their preview open
      openPreviews: {}
    }
  },

  computed: {
    getEmailURI: function () {
      var encodedText = encodeURIComponent('Reply to @school teacher message: ' + this.noticeObj.title)
      return 'mailto:' + this.noticeObj.teacher_email + '?subject=' + encodedText
    },
    tag: function () {
      if (parseInt(this.noticeObj.tag_important) === 1) {
        return 'IMPORTANT'
      } else if (parseInt(this.noticeObj.tag_event) === 1) {
        return 'EVENT'
      } else if (parseInt(this.noticeObj.tag_achievement) === 1) {
        return 'ACHIEVEMENT'
      } else if (this.noticeObj.type === 'msg') {
        return ''
      }
      return 'COMMON'
    },
    colourTag: function () {
      if (parseInt(this.noticeObj.tag_important) === 1) {
        return 'red'
      } else if (parseInt(this.noticeObj.tag_event) === 1) {
        return 'yellow darken-3'
      } else if (parseInt(this.noticeObj.tag_achievement) === 1) {
        return 'deep-purple lighten-1'
      } else if (this.noticeObj.type === 'msg') {
        return ''
      }
      return '#fb8c00'
    },
    disableReplyButton: function () {
      if (typeof this.noticeObj.disableReplyButton !== 'undefined') {
        return this.noticeObj.disableReplyButton
      } else {
        return true
      }
    }
  },

  methods: {
    toggleFavourite: function (id) {
      // var favValue = (this.favourite === 0) ? 1 : 0
      var postOrDelete = (this.favourite === 0) ? 'post' : 'delete'
      var url = 'caregiversV2/' + this.$store.state.Dbasename + '/' + this.$store.state.userId +
      '/favouritesV2/' + id
      var data = {
        type: this.noticeObj.type
      }

      if (postOrDelete === 'post') {
        this.$http.post(url, data)
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$http.delete(url, { data: data })
          .catch(function (error) {
            console.log(error)
          })
      }
      this.favourite = !this.favourite
      return this.favourite
    },

    // NEW: file preview helpers (same approach as NewsletterComponent.vue)
    getFileExtension: function (fileName) {
      if (!fileName) return ''
      return fileName.split('.').pop().toLowerCase()
    },

    getFileType: function (fileName) {
      const ext = this.getFileExtension(fileName)

      if (ext === 'pdf') {
        return 'pdf'
      } else if (['jpg', 'jpeg', 'png', 'gif'].includes(ext)) {
        return 'image'
      } else if (['doc', 'docx'].includes(ext)) {
        return 'word'
      } else {
        return 'other'
      }
    },

    getFileIcon: function (fileName) {
      const fileType = this.getFileType(fileName)

      if (fileType === 'pdf') {
        return 'fa-file-pdf'
      } else if (fileType === 'word') {
        return 'fa-file-word'
      } else if (fileType === 'image') {
        return 'fa-file-image'
      } else {
        return 'fa-file-alt'
      }
    },

    isPreviewable: function (fileName) {
      const fileType = this.getFileType(fileName)
      return fileType === 'pdf' || fileType === 'image'
    },

    togglePreview: function (file) {
      const id = file.id || file.filename
      this.$set(this.openPreviews, id, !this.isPreviewOpen(file))
    },

    isPreviewOpen: function (file) {
      const id = file.id || file.filename
      return this.openPreviews[id] || false
    }
  }
}
</script>

<style scoped>
.file-preview {
  border-radius: 4px;
  overflow: hidden;
}
</style>
